var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H28C34.6274 0 40 5.37258 40 12V28C40 34.6274 34.6274 40 28 40H12C5.37258 40 0 34.6274 0 28V12Z",
    fill: "#0591E8",
    fillOpacity: 0.094
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5833 25.8334H17.5C16.4182 25.8331 15.3578 25.532 14.4373 24.9637C13.5168 24.3955 12.7724 23.5825 12.2874 22.6155C11.8023 21.6486 11.5957 20.5658 11.6907 19.4882C11.7856 18.4106 12.1783 17.3806 12.8249 16.5133C13.4715 15.6461 14.3465 14.9757 15.3522 14.5771C16.3578 14.1785 17.4545 14.0674 18.5197 14.2562C19.5849 14.4451 20.5766 14.9264 21.3839 15.6464C22.1913 16.3664 22.7826 17.2967 23.0917 18.3334H24.5833C25.5779 18.3334 26.5317 18.7284 27.235 19.4317C27.9382 20.135 28.3333 21.0888 28.3333 22.0834C28.3333 23.0779 27.9382 24.0317 27.235 24.735C26.5317 25.4383 25.5779 25.8334 24.5833 25.8334Z",
    stroke: "#0591E8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/Cloud.470bda8e35d8d29f517923ca2ee6438a.svg";
export { ForwardRef as ReactComponent };